export default __webpack_public_path__ + "static/media/Folder_send_light2.bd7078f3.svg";